import { ActionIcon, CopyButton, Tooltip } from "@mantine/core";
import ContentCopyRounded from "@mui/icons-material/ContentCopyRounded";
import ContentPasteGoRounded from "@mui/icons-material/ContentPasteGoRounded";

export default function CustomCopyButton({
  value,
  defaultTooltip,
  copiedTooltip,
}: {
  value: string;
  defaultTooltip: string;
  copiedTooltip: string;
}) {
  return (
    <CopyButton value={value} timeout={2000} aria-label={defaultTooltip}>
      {({ copied, copy }) => (
        <Tooltip
          label={copied ? copiedTooltip : defaultTooltip}
          withArrow
          position="right"
        >
          <ActionIcon
          variant="subtle"
            color={copied ? "correct" : "lightblue"}
            onClick={copy}
            aria-label={copied ? "Copied" : "Copy"}
          >
            {copied ? (
              <ContentPasteGoRounded fontSize="small" />
            ) : (
              <ContentCopyRounded fontSize="small" />
            )}
          </ActionIcon>
        </Tooltip>
      )}
    </CopyButton>
  );
}
